import {isEqual} from "lodash";
import React from "react";

import {ETemplateTab, ITemplateNameId} from "@/components/template/models";

import {getTemplateWithId} from "@/components/template/EditTemplate";
import T from "@translate/T";

interface ITemplateProps {
    selected: number[];
}

interface ITemplateState {
    ids: ITemplateNameId[];
}

class Template extends React.PureComponent<ITemplateProps, ITemplateState> {
    public readonly state: ITemplateState = {ids: []};

    public async componentDidMount() {
        await this.retrieveSelected();
    }

    public async componentDidUpdate() {
        await this.retrieveSelected();
    }

    public render() {
        const {ids} = this.state;
        const filtered = ids.filter((x) => x.name !== "");

        if (!filtered.length) {
            return <T>None</T>;
        }

        return filtered.map((x) => x.name).join(", ");
    }

    private async retrieveSelected() {
        const {selected} = this.props;
        const {ids} = this.state;

        if (
            isEqual(
                selected,
                ids.map((x) => x.id),
            )
        ) {
            return;
        }

        const responses: ITemplateNameId[] = [];
        for (const id of selected) {
            const ele = await getTemplateWithId(id, ETemplateTab.Analysis);
            if (ele !== undefined) {
                responses.push(ele);
            } else {
                responses.push({id, name: ""});
            }
        }

        this.setState({ids: responses});
    }
}

export default Template;
